export const CLICK_PLANEJAMENTO_FILTER_BUTTON = 'CLICK_PLANEJAMENTO_FILTER_BUTTON';
export const ADD_FILTER_OPTIONS = 'ADD_FILTER_OPTIONS';
export const SET_CAPACIDADE_OPTIONS = 'SET_CAPACIDADE_OPTIONS';
export const SET_OCUPACAO_CAPACIDADE = 'SET_OCUPACAO_CAPACIDADE';
export const CLICK_CAPACIDADE_FILTER_CHECKBOX = 'CLICK_CAPACIDADE_FILTER_CHECKBOX';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_PROGRESS_LOADING = 'SHOW_STATIC_LOADING';
export const HIDE_PROGRESS_LOADING = 'HIDE_STATIC_LOADING';
export const ADD_CAPACIDADE_FABRICA = 'ADD_CAPACIDADE_FABRICA';
export const DEL_CAPACIDADE_FABRICA = 'DEL_CAPACIDADE_FABRICA';
export const CLEAN_CAPACIDADE_FABRICA = 'CLEAN_CAPACIDADE_FABRICA';
export const SET_CAPACIDADE_RECURSOS_CRITICOS = 'SET_CAPACIDADE_RECURSOS_CRITICOS';
export const SET_OCUPACAO_CAPACIDADE_RECURSOS_CRITICOS = 'SET_OCUPACAO_CAPACIDADE_RECURSOS_CRITICOS';
export const CLICK_RECURSO_CRITICO_FILTER_CHECKBOX = 'CLICK_RECURSO_CRITICO_FILTER_CHECKBOX';
export const SET_SELECT_CAPACIDADE_ORCADA = 'SET_SELECT_CAPACIDADE_ORCADA';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_WARNING = 'SHOW_WARNING';
export const SHOW_ERROR = 'SHOW_ERROR';
export const SET_CURRENT_DATA_PV = 'SET_CURRENT_DATA_PV';
export const SET_FILTROS_COLUNAS_PLANEJAMENTO = 'SET_FILTROS_COLUNAS_PLANEJAMENTO';
export const SET_VERSAO_SELECIONADA = 'SET_VERSAO_SELECIONADA';
export const SET_MODO_PRODUCAO = 'SET_MODO_PRODUCAO';
export const SET_MODO_REPOSICAO = 'SET_MODO_REPOSICAO';
export const SET_INTERVALO_GERAL = 'SET_INTERVALO_GERAL';
export const SET_INTERVALO_FILTRO = 'SET_INTERVALO_FILTRO';
export const DEL_INTERVALO_FILTRO = 'DEL_INTERVALO_FILTRO';
